import { tv } from 'tailwind-variants';

export const tag = tv({
  base: 'text-card-color-default px-1 py-0.5 rounded-sm text-sm',
  variants: {
    variant: {
      primary: 'bg-color-brand-primary',
      secondary: 'bg-brand-color-secondary-pure',
      neutral: 'bg-mono-color-lighter text-mono-color-black',
      onboarding: 'bg-incidencia-n3',
      disabled: 'bg-mono-color-lighter text-mono-color-medium',
      transparent: 'text-mono-color-black',
      white: 'bg-mono-color-white',
      alert: '',
      interdisciplinar: 'bg-disciplina-interdisciplinar',
      redacao: 'bg-disciplina-redacao',
      literatura: 'bg-disciplina-literatura',
      espanhol: 'bg-disciplina-espanhol',
      ingles: 'bg-disciplina-ingles',
      portugues: 'bg-disciplina-portugues',
      gramatica: 'bg-disciplina-portugues',
      sociologia: 'bg-disciplina-sociologia',
      filosofia: 'bg-disciplina-filosofia',
      geografia: 'bg-disciplina-geografia',
      historia: 'bg-disciplina-historia',
      matematica: 'bg-disciplina-matematica',
      fisica: 'bg-disciplina-fisica',
      quimica: 'bg-disciplina-quimica',
      biologia: 'bg-disciplina-biologia',
      atualidades: 'bg-disciplina-atualidades',
      'bioquimica-superior': 'bg-disciplina-bioquimica-superior',
      'anatomia-superior': 'bg-disciplina-anatomia-humana-superior',
      'histologia-humana-superior': 'bg-disciplina-histologia-humana-superior',
      'fisiologia-superior': 'bg-disciplina-fisiologia-humana-superior',
      'genetica-superior': 'bg-disciplina-genetica-superior',
      'embriologia-superior': 'bg-disciplina-embriologia-superior',
      'imunologia-superior': 'bg-disciplina-imunologia-superior',
      'microbiologia-superior': 'bg-disciplina-microbiologia-superior',
      'parasitologia-superior': 'bg-disciplina-parasitologia-superior',
      'patologia-superior': 'bg-disciplina-patologia-superior',
      'farmacologia-superior': 'bg-disciplina-farmacologia-superior',
      incidencia1: 'bg-incidencia-n1',
      incidencia2: 'bg-incidencia-n2',
      incidencia3: 'bg-incidencia-n3',
      incidencia4: 'bg-incidencia-n4',
      incidencia5: 'bg-incidencia-n5',
    },
  },
});
